//--------------------------------------------------------------------------------------------------
//# Imports

// import { Livepeer } from "@livepeer/ai";

export default { generateImage, generateText, astrologizerCall, alchemizerCall, imaginizerCall, alchmizerCall, alchmizerBatchCall, GETalchmizerBatchList, GETalchmizerBatch };








//--------------------------------------------------------------------------------------------------
//# Variables

let API_URL;
if (window.location.hostname === "localhost") {
  API_URL = 'http://localhost:3001';
} else {
  API_URL = 'https://alchm-backend.onrender.com';
};
const API_endpoints = {'text_to_image': '/generate-image',
                       'text_to_text': '/generate-text',
                       'astrologizer': '/astrologize',
                       'alchemizer': '/alchemize',
                       'imaginizer': '/imaginize',
                       'alchmizer': '/alchmize',
                       'alchmize-batch': '/alchmize-batch',
                       'GET-batch-list': '/avatar-batches',
                       'GET-batch': '/avatar-batch/:BID'};

const silent_mode = true;

// const livepeerAI = new Livepeer({
//   httpBearer: "",
// });









//--------------------------------------------------------------------------------------------------
//# Functions

export async function generateImage(parameter_dict) {
  console.log('\nAlchmizerOperator.js >>> RUNNING generateImage()');

  console.log('parameter_dict:', parameter_dict);
  
  console.log('generateImage() -> REQUEST SENT to', API_URL + API_endpoints['text_to_image']);
  try {
    const response = await fetch(API_URL + API_endpoints['text_to_image'], {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify(parameter_dict)
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    const data = await response.json()

    console.log('generateImage() -> RESPONSE RECEIVED from', API_URL + API_endpoints['text_to_image']);
    console.log('data', data);

    return(data.image_URL);

  } catch (error) {
    console.error('Error generating image:', error);
    return('error');
  } finally {
    console.log("Done generating image!");
  };
};


export async function generateText(parameter_dict) {
  console.log('\nAlchmizerOperator.js >>> RUNNING generateText()');

  console.log('parameter_dict:', parameter_dict);
  
  console.log('generateText() -> REQUEST SENT to', API_URL + API_endpoints['text_to_text']);
  try {
    const response = await fetch(API_URL + API_endpoints['text_to_text'], {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify(parameter_dict)
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    const data = await response.json()

    console.log('generateText() -> RESPONSE RECEIVED from', API_URL + API_endpoints['text_to_text']);
    console.log('data', data);

    return(data.generated_text);

  } catch (error) {
    console.error('Error generating text:', error);
    return('error');
  } finally {
    console.log("Done generating text!");
  };
};



export async function astrologizerCall(alchm_info) {
  console.log('\nAlchmizerOperator.js >>> RUNNING astrologizerCall()');

  console.log('birth_info:', alchm_info.birth_info);
  
  console.log('astrologizerCall() -> REQUEST SENT to', API_URL + API_endpoints['astrologizer']);
  try {
    const response = await fetch(API_URL + API_endpoints['astrologizer'], {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify(alchm_info)
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    alchm_info = await response.json();

    console.log('astrologizerCall() -> RESPONSE RECEIVED from', API_URL + API_endpoints['astrologizer']);
    console.log('alchm_info', alchm_info);

    return(alchm_info);

  } catch (error) {
    console.error('Error Astrologizing:', error);
    return('error');
  } finally {
    console.log("Done Astrologizing!");
  };
};


export async function alchemizerCall(alchm_info) {
  console.log('\nAlchmizerOperator.js >>> RUNNING alchemizerCall()');

  console.log('birth_info:', alchm_info.birth_info);
  console.log('astrology_info:', alchm_info.astrology_info);
  
  console.log('alchemizerCall() -> REQUEST SENT to', API_URL + API_endpoints['alchemizer']);
  try {
    const response = await fetch(API_URL + API_endpoints['alchemizer'], {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify(alchm_info)
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    alchm_info = await response.json()

    console.log('alchemizerCall() -> RESPONSE RECEIVED from', API_URL + API_endpoints['alchemizer']);
    if (!silent_mode){
      console.log('alchm_info', alchm_info);
    };

    return(alchm_info);

  } catch (error) {
    console.error('Error Alchemizing:', error);
    return('error');
  } finally {
    console.log("Done Alchemizing!");
  };
};



export async function imaginizerCall(alchm_info) {
  console.log('\nAlchmizerOperator.js >>> RUNNING imaginizerCall()');

  console.log('birth_info:', alchm_info['birth_info']);
  console.log('astrology_info:', alchm_info['astrology_info']);
  console.log('alchemy_info:', alchm_info['alchemy_info']);
  
  console.log('imaginizerCall() -> REQUEST SENT to', API_URL + API_endpoints['imaginizer']);
  try {
    const response = await fetch(API_URL + API_endpoints['imaginizer'], {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
        },
      body: JSON.stringify(alchm_info)
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    alchm_info = await response.json()

    console.log('imaginizerCall() -> RESPONSE RECEIVED from', API_URL + API_endpoints['imaginizer']);
    
    if (!silent_mode){
      console.log('alchm_info', alchm_info);
    };

    return(alchm_info);

  } catch (error) {
    console.error('Error Imaginizing:', error);
    return('error');
  } finally {
    console.log("Done Imaginizing!");
  };
};


export async function alchmizerCall(alchm_info, access_token="") {
  console.log('\nAlchmizerOperator.js >>> RUNNING alchmizerCall()');

  console.log('imaginizer_info:', alchm_info['imaginizer_info']);

  if (access_token) {
    console.log('alchmizerCall() -> REQUEST SENT to', API_URL + API_endpoints['alchmizer']);
    try {
      const response = await fetch(API_URL + API_endpoints['alchmizer'], {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}`,
          },
        body: JSON.stringify(alchm_info)
      })
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      };
      alchm_info = await response.json()

      console.log('alchmizerCall() -> RESPONSE RECEIVED from', API_URL + API_endpoints['alchmizer']);
      if (!silent_mode){
        console.log('alchm_info', alchm_info);
      };

      return(alchm_info);

    } catch (error) {
      console.error('Error Alchmizing:', error);
      return('error');
    } finally {
      console.log("Done Alchmizing!");
    };
  } else {
    console.log('alchmizerCall() -> REQUEST SENT to', API_URL + API_endpoints['alchmizer'] + '-public');
    try {
      const response = await fetch(API_URL + API_endpoints['alchmizer'] + '-public', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
          },
        body: JSON.stringify(alchm_info)
      })
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      };
      alchm_info = await response.json()

      console.log('alchmizerCall() -> RESPONSE RECEIVED from', API_URL + API_endpoints['alchmizer']);
      if (!silent_mode){
        console.log('alchm_info', alchm_info);
      };

      return(alchm_info);

    } catch (error) {
      console.error('Error Alchmizing:', error);
      return('error');
    } finally {
      console.log("Done Alchmizing!");
    };
  };
};


export async function alchmizerBatchCall(batch_settings, access_token="") {
  console.log('\nAlchmizerOperator.js >>> RUNNING alchmizerBatchCall()');

  console.log('batch_settings:', batch_settings);

  console.log('alchmizerBatchCall() -> REQUEST SENT to', API_URL + API_endpoints['alchmize-batch']);
  try {
    const response = await fetch(API_URL + API_endpoints['alchmize-batch'], {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${access_token}`,
        },
      body: JSON.stringify(batch_settings)
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    // batch_settings = await response.json()

    const blob = await response.blob();

    const cd = response.headers.get("content-disposition") || "";
    const match = cd.match(/filename="([^"]+)"/);
    const filename = match?.[1] || "alchemy_info.csv";

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    console.log('alchmizerBatchCall() -> RESPONSE RECEIVED from', API_URL + API_endpoints['alchmize-batch']);
    if (!silent_mode){
      console.log('alchm_info', batch_settings);
    };

    return(batch_settings);

  } catch (error) {
    console.error('Error Alchmizing Batch:', error);
    return('error');
  } finally {
    console.log("Done Alchmizing Batch!");
  };
};




export async function GETalchmizerBatchList(access_token) {
  console.log('\nAlchmizerOperator.js >>> RUNNING GETalchmizerBatchList()');

  console.log('GETalchmizerBatchList() -> REQUEST SENT to', API_URL + API_endpoints['GET-batch-list']);
  try {
    const response = await fetch(API_URL + API_endpoints['GET-batch-list'], {
      method: 'GET',
      headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    
    const data = await response.json();
    const list = data?.batches;

    if (!Array.isArray(list)) {
      throw new Error("Unexpected response shape: expected { batches: [...] }");
    }

    console.log('GETalchmizerBatchList() -> RESPONSE RECEIVED from', API_URL + API_endpoints['GET-batch-list']);
    if (!silent_mode){
      console.log('list', list);
    };

    return(list);

  } catch (error) {
    console.error('Error Getting Batches:', error);
    return('error');
  } finally {
    console.log("Done Getting Batches!");
  };
};



export async function GETalchmizerBatch(BID, access_token) {
  console.log('\nAlchmizerOperator.js >>> RUNNING GETalchmizerBatch()');

  const URL = API_URL + API_endpoints['GET-batch'].split(':')[0] + encodeURIComponent(BID);

  console.log('GETalchmizerBatch() -> REQUEST SENT to', URL);
  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
    })
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    };
    
    const data = response.json();
    // const list = data?.batches;

    // if (!Array.isArray(list)) {
    //   throw new Error("Unexpected response shape: expected { batches: [...] }");
    // }

    console.log('GETalchmizerBatch() -> RESPONSE RECEIVED from', URL);
    if (!silent_mode) {
      console.log('data', data);
    };

    return(data);

  } catch (error) {
    console.error('Error Getting Batch:', error);
    return('error');
  } finally {
    console.log("Done Getting Batch!");
  };
};